











































import ActionButton from '@/components/ActionButton.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import PriceSettings from '@/components/Services/Remittances/PriceSettings/PriceSettings.vue'
import PriceSettingsDialog from '@/components/Services/Remittances/PriceSettings/PriceSettingsDialog.vue'
import {
  AutoUp,
  RemittancePrice,
} from '@/utils/interfaces/remittance.interface'
import { autoUpController } from '@/api/Remittances/remittances.api'
import IconButton from '~/components/IconButton.vue'
import AutoUpCrudDialog from '~/components/Services/Remittances/AutoUpCrudDialog.vue'
import AutoUpFilter from '~/components/Services/Remittances/AutoUpFilter.vue'
import TableSwitch from '~/components/TableSwitch.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default tableHandler<AutoUp>().extend({
  components: {
    appActionButton: ActionButton,
    appPriceSettings: PriceSettings,
    appPriceSettingsDialog: PriceSettingsDialog,
    IconButton,
    AutoUpCrudDialog,
    AutoUpFilter,
    TableSwitch,
    FlatCard,
    FlatTable,
    TextButton,
  },
  data() {
    return {
      filterModel: false,
      dialogModel: false,
      getter: autoUpController.getter,
      toggle: autoUpController.toggle,
      priceItem: null as null | RemittancePrice,
      headers: [
        {
          text: this.$t('agency.agency'),
          value: 'agency_name',
        },
        {
          text: this.$t('delivery_currency'),
          value: 'delivery_currency',
        },
        {
          text: this.$t('regions'),
          value: 'regions_data',
        },
        {
          text: this.$t('is_active'),
          value: 'is_active',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ],
    }
  },
})
